import { ComplianceReportOutputFormatEnum } from "@herbjoy/apex-api-models";

export const complianceReportOutputFormatEnum = {
    1: ComplianceReportOutputFormatEnum.MultipleWorksheets,
    2: ComplianceReportOutputFormatEnum.SingleMergedWorksheet
};

export interface ComplianceReportOutputFormatSelect {
    Id: ComplianceReportOutputFormatEnum;
    Name: string;
}

export function parseComplianceReportOutputFormat(id: number): ComplianceReportOutputFormatEnum {
    return complianceReportOutputFormatEnum[id];
}

export const complianceReportOutputFormatList: ComplianceReportOutputFormatSelect[] = [
    {
        Id: ComplianceReportOutputFormatEnum.MultipleWorksheets,
        Name: "Multiple Worksheets"
    },
    {
        Id: ComplianceReportOutputFormatEnum.SingleMergedWorksheet,
        Name: "Single Merged Worksheet"
    }
];
